import React from 'react';
import LogoColor from '../elements/LogoColor';


const FooterLegals = () =>(
    
        <>                
            <LogoColor />
            <small>XDNEO. Todos los derechos reservados</small>
        </>
    )

export default FooterLegals;